<template>

	<div v-if="product && order">

		<div class="row margin-t-150">

			<article class="wrap--product">

				<div class="col-12 margin-tb-50">

					<a href="/">Se alle Produkter</a>

				</div>

				<section class="product">

					<div class="img margin-b-25">

						<img :srcset="sourceSet" :src="'/storage/images/' + product.image" :alt="product.title">

					</div>

					<div class="content">

						<div class="col-12">

						</div>

						<h1>{{product.title}}</h1>

						<nl2br tag="p" :text="product.description"></nl2br>

						<a href="https://wiki.naesbyhovedskov.dk/" target="_blank">Se tilberedning & levering her</a>

						<h3>Pris pr. stk.</h3>

						<h4>{{stripeAmount(product.price).amount}},-</h4>

						<ul>
							<li><i class="icon--md fas fa-info-circle"></i> Minimumsbestilling er {{product.min_quantity}} stk.</li>
							<li v-if="!product.category_exceptions || !product.category_exceptions.order_before"><i class="icon--md fas fa-info-circle"></i> Kan tidligst bestilles til {{ new Date() | moment("add", "8 days") | moment('dddd [d.] Do MMMM') }}</li>
							<li v-else><i class="icon--md fas fa-info-circle"></i> Kan bestilles indtil {{ product.category_exceptions.order_before  | moment('dddd [d.] Do MMMM') }}</li>
							<li><i class="icon--md fas fa-info-circle"></i> Alle retter afhentes / afleveres kolde</li>
						</ul>

						<div class="col-12 margin-t-25">

							<incrementer v-model="quantity" :min="product.min_quantity"></incrementer>

						</div>

					</div>

				</section>

			</article>

		</div>

		<div class="row">

            <selection v-for="selection in product.selections" :selection="selection" :key="selection.title"></selection>

		</div>

		<div class="row">

			<div class="addons" v-for="selection in product.extra_selections">

				<article class="wrap--product">

					<header class="addons__header border-b padding-b-25 margin-b-50">

						<h1>Tilkøb - {{selection.title}} </h1>

					</header>

					<main class="addons__items">

						<option-item v-for="option in selection.options" :option="option" :selection="selection" :as-extra="true" :key="option.id"></option-item>

					</main>

				</article>

			</div>

		</div>

		<total></total>

	</div>

</template>

<script>
	import {mapGetters} from 'vuex';
	import PlusMinusNumberInput from './../partials/PlusMinusNumberInput.vue';
	import Option from './partials/option.vue';
	import Total from './partials/total.vue';
	import Selection from './partials/selection.vue';
    export default {
        name: "Product",
		components:{
          	'incrementer':PlusMinusNumberInput,
			'option-item':Option,
            Selection,
			Total
		},
		computed:{
			...mapGetters({
				product:'product',
				order:'order',
			}),
			quantity:{
			    get(){
					return this.order.details.quantity;
				},
				set(value){
					this.$store.dispatch('setQuantity', value);
				}
			},
			sourceSet(){
			    return '/storage/images/' + this.product.image_x1 + ' 1x, ' + '/storage/images/' + this.product.image + ' 2x';
			}
		},
		watch:{
            product(value){
				this.setupFlow(value);
			}
		},
		methods:{
          	setupFlow(value){
                this.$store.dispatch('setOrderProduct', value);
                this.$store.dispatch('setQuantity', value.min_quantity);
                this.$store.dispatch('setSelections', value.selections);
                this.$store.dispatch('setExtraSelections', value.extra_selections);
			},
		},
    }
</script>

<style scoped>

</style>
